document.addEventListener('DOMContentLoaded', function() {
  const breadcrumbs = $('[data-sticky-breadcrumbs]');

  if (breadcrumbs.length === 0) {
    return;
  }

  let lastScrollTop = 0;
  let headerHeight = 0;

  const updateSticky = () => {
    const stickyOptions = {
      marginTop: headerHeight / 16,
      anchor: 'page-content'
    };

    window.contentPagesStickyBreadcrumbs = new Foundation.Sticky(
      breadcrumbs,
      stickyOptions
    );
  };

  window.addEventListener(
    'scroll',
    () => {
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop) {
        // Scrolling down
        headerHeight = 0;
      } else {
        // Scrolling up
        headerHeight = document.querySelector('.page-header')?.offsetHeight;
      }

      updateSticky();
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For negative scrolling
    },
    false
  );

  updateSticky();
  // We need to trigger the load event for Sticky because of Turbolinks
  window.dispatchEvent(new Event('load.zf.sticky'));
});

document.addEventListener('turbo:before-render', function() {
  if (window.contentPagesStickyBreadcrumbs !== undefined) {
    delete window.contentPagesStickyBreadcrumbs;
  }
});
